// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, db } from '../firebase';
import { onAuthStateChanged, signOut as firebaseSignOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

// console.log("AuthContext: Verifying imported 'db' object:", db); // Can be removed now

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null); // Will store the raw Firebase User object
  const [userProfile, setUserProfile] = useState(null); // Will store { firstName, lastName, ... }
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      // console.log("AuthContext LOG 1: onAuthStateChanged user:", user);
      if (user) {
        setCurrentUser(user); // Store the raw Firebase user object
        try {
          // console.log("AuthContext LOG 1.5: Entered 'if (user)' block for UID:", user.uid);
          // console.log("AuthContext LOG 1.8: Entered 'try' block. Attempting Firestore fetch...");
          const userDocRef = doc(db, "users", user.uid);
          const userDocSnap = await getDoc(userDocRef);
          // console.log("AuthContext LOG 2: Firestore docSnap exists for UID", user.uid + "? :", userDocSnap.exists());
          if (userDocSnap.exists()) {
            // console.log("AuthContext LOG 3: Firestore docSnap data:", userDocSnap.data());
            setUserProfile(userDocSnap.data()); // Set the profile data separately
            // console.log("AuthContext LOG 4: userProfile set with:", userDocSnap.data());
          } else {
            // console.log("AuthContext LOG 5: No profile in Firestore for UID:", user.uid);
            setUserProfile(null); // No profile data found
          }
        } catch (error) {
          // console.error("AuthContext LOG 6: Error fetching user profile:", error);
          setUserProfile(null); // Error fetching profile
        }
      } else {
        setCurrentUser(null);
        setUserProfile(null); // Clear profile on logout
        // console.log("AuthContext: User is null (logged out).");
      }
      setLoading(false);
      // console.log("AuthContext LOG 7: setLoading(false) executed. Current loading state:", false);
    });
    return unsubscribe;
  }, []);

  const signout = async () => {
    await firebaseSignOut(auth);
    // onAuthStateChanged will handle setting currentUser and userProfile to null
  };

  const value = {
    currentUser,  // This is the Firebase User object (has .getIdToken(), .uid, .email)
    userProfile,  // This is your Firestore data { firstName, lastName }
    loading,      // Still providing loading state
    signout,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}